import React from "react";
import { Phone, Radio } from "lucide-react";

const WAVE_BARS = [0, 1, 2, 3, 4, 5, 6];

const AppBootLoader = ({ isDark = true }) => (
  <div
    className={`app-boot-loader ${isDark ? "app-boot-loader--dark" : "app-boot-loader--light"}`}
    role="status"
    aria-live="polite"
    aria-label="Panel yükleniyor"
  >
    <div className="app-boot-loader-grid" aria-hidden="true" />
    <div className="app-boot-loader-glow" aria-hidden="true" />

    <div className="app-boot-loader-card">
      <div className="app-boot-loader-visual">
        <span className="app-boot-loader-ring app-boot-loader-ring--1" aria-hidden="true" />
        <span className="app-boot-loader-ring app-boot-loader-ring--2" aria-hidden="true" />
        <span className="app-boot-loader-ring app-boot-loader-ring--3" aria-hidden="true" />
        <div className="app-boot-loader-icon-wrap">
          <Phone className="app-boot-loader-phone" strokeWidth={2.2} aria-hidden="true" />
          <Radio className="app-boot-loader-signal" strokeWidth={2.2} aria-hidden="true" />
        </div>
      </div>

      <div className="app-boot-loader-wave" aria-hidden="true">
        {WAVE_BARS.map((i) => (
          <span key={i} className="app-boot-loader-bar" style={{ animationDelay: `${i * 0.09}s` }} />
        ))}
      </div>

      <p className="app-boot-loader-title">CDR Control Panel</p>
      <p className="app-boot-loader-sub">
        Çağrı merkezi bağlantısı kuruluyor
        <span className="app-boot-loader-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </p>
    </div>
  </div>
);

export default AppBootLoader;
